import { useAppsListQuery } from '../hooks/useAppsListQuery'
import { useSelector, useDispatch } from 'react-redux'
import {
  ToolbarItem,
  setActiveItem,
} from '../../../common/components/ToolbarItem'
import { appsListSlice } from '../AppsList/appsListSlice'
import { LayoutGrid } from 'lucide-react'
import { authSlice } from '@wellesley/auth'
import { useActiveGroupName } from '../hooks/useActiveGroupName'
import { useEffect } from 'react'
import { useOpenLastApp } from '../AppsList'
import { userSlice } from '@wellesley/user'

const id = 'user-apps'
export const UserApps = () => {
  const dispatch = useDispatch()
  const isLogin = useSelector(authSlice.selectors.selectIsAuthenticated)
  const currentUser = useSelector(userSlice.selectors.selectCurrentUser)

  const activeGroupName = useActiveGroupName()
  const getApps = useAppsListQuery()
  const { openLastApp } = useOpenLastApp()

  const handleSetApps = async () => {
    dispatch(setActiveItem(id))
    const list = await getApps()
    list &&
      dispatch(
        appsListSlice.actions.setList({
          list,
          entryPoint: isLogin ? 'USER' : 'GLOBAL',
        }),
      )
  }

  const handleClick = async () => {
    await handleSetApps()
    openLastApp(currentUser?.username || 'global')
  }

  useEffect(() => {
    !activeGroupName && void handleSetApps()
  }, [activeGroupName, getApps, dispatch, isLogin])

  return (
    <ToolbarItem id={id} Icon={LayoutGrid} onClick={() => void handleClick()} />
  )
}
